import opConfig from 'openpathConfig';

export const getCloudServerRegions = async () => {
  const HeliumEndpoint = opConfig.PORTAL_API_URL;
  const regionsResponse = await fetch(`${HeliumEndpoint}/cloudServerRegions`);
  const regions: {
    data: Api.Response['listCloudServerRegions'];
  } = await regionsResponse.json();

  return regions;
};
